var styles = {
    color: {
        headerFont: '#666',
        icon: '#fff',
        socialIcons: '#000'
    },
    fontFamily: {
        headerFontFamily: 'arial'
    },
    fontSize: {
        headerFontSize: '.875rem'
    }
};
export default styles;
